import { v4 as uuid } from 'uuid';

import { BlockType, PracticalAssessmentVideoBlock } from './types';
import { RBlock, RBlockInput, RBlockV2Type } from '@/store/v2';
import { BlockId } from '@/administration/pages/Course/store/types';

export const createPracticalAssessmentVideoBlock = (): PracticalAssessmentVideoBlock => ({
  id: `block-l-${uuid()}` as BlockId,
  type: BlockType.PRACTICAL_ASSESSMENT_VIDEO,
  description: '[{"children":[{"text":""}]}]',
  peerReviewEnabled: true,
});

export const transformPracticalAssessmentVideoBlockToRemoteInput = (
  block: PracticalAssessmentVideoBlock,
  rPageId?: number,
  order?: number,
): RBlockInput => ({
  id: block?.remoteId || undefined,
  type: RBlockV2Type.PracticalAssessmentTask,
  order: order || 0,
  pageId: rPageId || undefined,
  data: {
    description: block.description,
    type: BlockType.PRACTICAL_ASSESSMENT_VIDEO,
    peerReviewEnabled: block.peerReviewEnabled,
  },
});

export const transformPracticalAssessmentVideoBlockFromRemote = (rBlock: RBlock): PracticalAssessmentVideoBlock => ({
  id: `block-r-${rBlock.id || 0}` as BlockId,
  remoteId: rBlock.id || 0,
  type: BlockType.PRACTICAL_ASSESSMENT_VIDEO,
  description: rBlock.data.description || '[{"children":[{"text":""}]}]',
  peerReviewEnabled: Boolean(rBlock.data.peerReviewEnabled),
});
